import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useJobInsights } from '../../../hooks/useJobInsights';

const JobSearchInsights = () => {
  const { insights, isLoading, error, refreshInsights } = useJobInsights();
  
  // Default insights as fallback
  const defaultInsights = [
    {
      type: 'skill_gap',
      title: 'Close Skill Gap',
      description: 'Adding Project Management skills can increase your matches by 35%',
      icon: 'TrendingUp',
      action: {
        label: 'Add Skills',
        url: '/up-skills'
      },
      color: 'bg-blue-50 text-blue-600'
    },
    {
      type: 'profile_completion',
      title: 'Complete Your Profile',
      description: 'Profiles with portfolios get 2x more interview requests',
      icon: 'Star',
      action: {
        label: 'Add Portfolio',
        url: '/va-portfolio-management'
      },
      color: 'bg-purple-50 text-purple-600'
    },
    /* {
      type: 'application_tip',
      title: 'Application Tip',
      description: 'Personalized cover letters increase your response rate by 40%',
      icon: 'FileText',
      action: {
        label: 'Learn More',
        url: '#'
      },
      color: 'bg-green-50 text-green-600'
    } */
  ];

  const displayInsights = insights.length > 0 ? insights : defaultInsights;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-800">Job Insights</h3>
        {<Button
          variant="ghost"
          size="sm"
          iconName={isLoading ? "Loader" : "RefreshCw"}
          className={`text-text-secondary ${isLoading ? "" : ""}`}
          onClick={refreshInsights}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Refresh"}
        </Button>}
      </div>

      {error && (
        <div className="p-3 mb-3 rounded-lg bg-red-50 text-red-600">
          <p className="text-sm">Failed to load insights. Please try again.</p>
        </div>
      )}

      <div className="space-y-3">
        {isLoading ? (
          <div className="flex items-center justify-center py-6">
            <Icon name="Loader" size={24} className="animate-spin text-primary" />
          </div>
        ) : (
          displayInsights.map((insight, index) => (
            <div
              key={index}
              className={`p-3 rounded-lg ${insight.color || 'bg-blue-50 text-blue-600'} flex items-start`}
            >
            <div className="mr-3 mt-1">
              <Icon name={insight.icon} size={18} />
            </div>
            <div className="flex-1">
              <h4 className="font-medium text-sm mb-1">{insight.title}</h4>
              <p className="text-xs mb-2 opacity-90">{insight.description}</p>
              {insight.action && (
                <Button
                  variant="ghost"
                  size="xs"
                  className="p-0 underline hover:no-underline"
                  onClick={() => window.location.href = insight.action.url}
                >
                  {insight.action.label}
                </Button>
              )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default JobSearchInsights;

